var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"lang"}},[_c('a',{attrs:{"href":("/" + (_vm.$t('other-lang-path')) + "/" + _vm.pageId)},on:{"click":function($event){_vm.recordLang(_vm.$t('other-lang-path'));}}},[_vm._v(_vm._s(_vm.$t("other-lang-label")))])])}
var staticRenderFns = []

export { render, staticRenderFns }